
export interface Comment {
    author: string;
    text: string;
}

export const Comments: Comment[] = [
    {
        author: "Agata M.",
        text: "Bardzo dobry kontakt, dobra obsługa trychologiczna, szybka pomoc i masa porad. Pani Ewa podchodzi bardzo indywidualnie do problemu. Polecam wszystkim osobom które szukają pomocy w sprawie włosów i skóry głowy."
    },
    {
        author: "Monika G.",
        text: "Do gabinetu TrychoMedical trafiłam z ogromnym problemem jakim jest wypadanie włosów. Przez covid-19 gubiłam je w bardzo szybkim tempie. Uzyskałam natychmiast pomoc. Pani Trycholog niezwykle miła i ciepła osoba a przy tym pełny profesjonalizm!"
    },
    {
        author: "Julia C.",
        text: "Pani Trycholog precyzyjnie znajduje przyczynę problemu, szczegółowo ją omawiając. Stosowana terapia jest skuteczna i po krótkim czasie widać pierwsze rezultaty. Pani Ania wykonuje swoją pracę z wielkim zaangażowaniem i profesjonalizmem."
    },
    {
        author: "Damian K.",
        text: "Pani Trycholog podczas wywiadu zadawała dużo pytań oraz zrobiła badanie głowy. Wzbudziła moje zaufanie swoją ogromną wiedzą oraz dokładnością. Na pewno będę kontynuować leczenie w tym miejscu. Polecam!"
    },
    {
        author: "Michał N.",
        text: "Rewelacja! Gabinet położony w samym centrum miasta, więc łatwy dojazd. Samo przeprowadzanie wywiadu czy zabiegów odbywa się w bardzo kameralnej, spokojnej atmosferze. W dodatku Pani Trycholog poradzi sobie z każdym problemem \"włosowym\"."
    },
];